'use client';

import React, { useMemo } from 'react';

import { Button } from '@nextui-org/react';
import { ChevronRight } from 'lucide-react';

import { MasterclassCard } from '@/components/masterclass/masterclass-card';
import { McSkeletonCard } from '@/components/masterclass/mc-skeleton-card';
import { Carousel } from '@/components/ui/apple-cards-carousel';
import { IMasterclass } from '@/entities/masterclass/types';
import { Link } from '@/shared/navigation';
import { ROUTES } from '@/shared/routes/routes';

interface McsListProps {
  masterclasses: IMasterclass[];
  isPending: boolean;
}
export const McsList = ({ masterclasses, isPending }: McsListProps) => {
  const cards = useMemo(() => {
    const items = !isPending
      ? masterclasses.map((mc, index) => (
          <div className="w-[220px] md:w-[280px]" key={mc.id}>
            <MasterclassCard
              isPending={isPending}
              withCartButton={false}
              masterclass={mc}
            />
          </div>
        ))
      : Array.from({ length: 4 }).map((_, index) => {
          return (
            <div className="w-[220px] md:w-[280px]" key={index}>
              <McSkeletonCard key={index} />
            </div>
          );
        });
    items.push(
      <div className="h-full flex items-center justify-center">
        <Link
          className="text-gray-900 w-[150px] flex items-center gap-2 flex-col"
          href={ROUTES.masterclasses}
        >
          <Button isIconOnly variant="faded" aria-label="see more">
            <ChevronRight className="h-6 w-6 text-gray-500" />
          </Button>
          Смотреть все
        </Link>
      </div>,
    );
    return items;
  }, [masterclasses, isPending]);
  return (
    <>
      <Carousel items={cards} />

      {/*<div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-6">*/}
      {/*  {isPending ? (*/}
      {/*    <>*/}
      {/*      {Array.from({ length: 7 }).map((_, index) => {*/}
      {/*        return <McSkeletonCard key={index} />;*/}
      {/*      })}*/}
      {/*    </>*/}
      {/*  ) : (*/}
      {/*    <>*/}
      {/*      {masterclasses?.map((mc) => {*/}
      {/*        return <MasterclassCard masterclass={mc} key={mc.id} />;*/}
      {/*      })}*/}
      {/*    </>*/}
      {/*  )}*/}
      {/*</div>*/}
      {/*{!isPending && masterclasses?.length === 0 && <SearchEmpty />}*/}
    </>
  );
};
